/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jul 22 2024
 **/

/**
 * @description
 *  ref : SwaggerModels.SpaceSceneType
 */
export const SPACE_SCENE_TYPE = {
	LOBBY: "LOBBY",
	MEETING_ROOM: "MEETING_ROOM",
	MY_ROOM: "MY_ROOM",
	OPEN_WORLD: "OPEN_WORLD"
} as const;

export type SpaceSceneType = (typeof SPACE_SCENE_TYPE)[keyof typeof SPACE_SCENE_TYPE];
